import * as React from 'react';
import { useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import PageWrapper from '../components/Common/PageWrapper/PageWrapper';
import HeroSection from '../components/Sections/HomePage/HeroSection/HeroSection';
import InfoSection from '../components/Sections/HomePage/InfoSection/InfoSection';
import ServicesSection from '../components/Sections/HomePage/ServicesSection/ServicesSection';
import { PagesList } from '../enums/PagesList';
import { Application } from '../interfaces/professional/Professional';
import { TemplatesList } from '../enums/TemplatesList';
import {sectorsTranslation, serviceTranslation} from '../utils/translationsUtils';

const Index = ({ data, location: windowLocation }: Application) => {
  const { t } = useTranslation();
  const { services, description, longName, sectors, picture, businessInfo, customSectors, location, template } = data.professional.data;
  console.log('sectors', sectors);
  const [activeServiceIds, setActiveServiceIds] = useState<Array<string>>([]);

  useEffect(() => {
    if (services[0]) {
      setActiveServiceIds([services[0].id]);
    }
  }, [services]);

  const setActiveServiceIdHandler = (id: string) => {
    if (activeServiceIds.some(item => item === id)) {
      setActiveServiceIds(activeServiceIds.filter(item => item !== id));
      return;
    }
    setActiveServiceIds([...activeServiceIds, id]);
  };

  const { language } = useI18next();

  const allSectors = sectorsTranslation(sectors, language as "en" | "fr")
    .map(item => item.title)
    .concat(customSectors)
    .join(', ');


  const translatedSectors = sectorsTranslation(sectors, language as "en" | "fr");
  const translatedServices = services.map(it => serviceTranslation(it, language as "en" | "fr"));

  return (
    <PageWrapper
      template={template.template as TemplatesList}
      currentPage={t('header.menu.home.label')}
      color={template.color}
      pageId={PagesList.HOME}
      metaDescription={description}
      metaTitle={t('SEO.home.title', { longName: longName, sectorsList: allSectors })}
      windowLocation={windowLocation}
    >
      <HeroSection
        longTitle={longName}
        address={location.placeDescription}
        sectorsList={translatedSectors.map(sectors => sectors.title).concat(customSectors)}
        template={template.template as TemplatesList}
        userAvatar={picture?.url}
        phoneNumber={businessInfo.phone}
      />
      <InfoSection
        aboutText={description}
        phone={businessInfo.phone}
        avatar={picture?.url}
        email={businessInfo.email}
        template={template.template as TemplatesList}
      />
      <ServicesSection
        services={translatedServices}
        activeServiceId={activeServiceIds}
        setActiveService={setActiveServiceIdHandler}
        template={template.template as TemplatesList}
      />
    </PageWrapper>
  );
};

export default Index;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    professional {
      data {
        template {
          template
          color
        }
        shortName
        longName
        description
        businessInfo {
          email
          phone
          euVatNumber
          officialId
          paymentMethod
        }
        customSectors
        sectors {
          id
          title
          activityType
          pictures {
            id
            url
            group
            description
          }
          benefits {
            title
            translated {
              en
              fr
            }
          }
          malePractitioner
          femalePractitioner
          descriptionTitle
          descriptionSubTitle
          shortDescription
          longDescription
          specialties {
            id
            title
          }
        }
        picture {
          id
          url
          group
          description
        }
        location {
          placeDescription
          placeId
          name
          longitude
          latitude
        }
        services {
          id
          isPrimary
          customSector
          sector {
            id
            title
            activityType
            pictures {
              id
              url
              group
              description
            }
            benefits {
              title
              translated {
                en
                fr
              }
            }
            malePractitioner
            femalePractitioner
            descriptionTitle
            descriptionSubTitle
            shortDescription
            longDescription
            specialties {
              id
              title
              translated {
                en
                fr
              }
            }
          }
          specialties {
            id
            title
            translated {
              en
              fr
            }
          }
          customSpecialties
          customHelps
          customAppointmentTypes
          appointmentTypes {
            id
            title
          }
          experience {
            year
            explanatory
            hideOnSite
          }
          helps {
            title
            translated {
              en
              fr
            }
          }
          targetAudience
          rates {
            description
            price
            currency
            active
          }
          ratesDescription
          picture {
            id
            url
            group
            description
          }
        }
      }
    }
  }
`;
